import React from 'react';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';
import utils from 'helpers/utils';

const BooleanField = (props) => {
    const { defaultStyle, elStyle, source, record = {}, trueValue, falseValue } = props;

    let value = utils.get(record, source);

    value = value ? trueValue : falseValue;

    const style = Object.assign({}, defaultStyle, elStyle);

    return (
        <div style={ style }>{ value }</div>
    );
};

BooleanField.defaultProps = {
    addLabel: true,
    falseValue: null,
    defaultStyle: {
        textAlign: 'center',
    },
    trueValue: 'true',
};

BooleanField.propTypes = {
    defaultStyle: PropTypes.object,
    elStyle: PropTypes.object,
    falseValue: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
    ]),
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
    trueValue: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
    ]),
};

export default pure(BooleanField);



// WEBPACK FOOTER //
// ./src/components/field/BooleanField.js